import { WarehouseResponseData } from "./warehouse-response.data";

export class RackDashboard {
    rackId: number;
    rackName: string;
    colCount: number;
    rackPositions: WarehouseResponseData[]
}